import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Programs.css';
import SearchScreenNav from '../components/SearchScreenNav';

const Programs = () => {
  return (
    <div className="programs-page-container">
      <Helmet>
        <title>Programs | LGBT PridePath</title>
        <meta name="description" content="Explore LGBT National Help Center programs including the LGBT National Hotline (888-843-4564), Youth Talkline, Senior Hotline, and online chat services." />
        <link rel="canonical" href="https://www.lgbtpridepath.org/programs" />
        <meta property="og:title" content="Programs | LGBT PridePath" />
        <meta property="og:description" content="Free, confidential LGBTQ+ support services including hotlines, youth talkline, senior hotline, and online chat." />
        <meta property="og:url" content="https://www.lgbtpridepath.org/programs" />
        <meta property="og:type" content="website" />
      </Helmet>
      
      {/* Custom navigation for overlay effect */}
      <SearchScreenNav />
      
      {/* Hero image container - positioned OUTSIDE content wrapper */}
      <div className="programs-hero-image-container">
        <img src={require('../assets/header-programs.png')} alt="Community support" />
      </div>
      
      {/* Content wrapper matching Contact structure */}
      <div className="programs-content-wrapper">
        {/* Hero section */}
        <div className="programs-hero-section">
          <h2 className="programs-hero-subtitle">PROGRAMS</h2>
          <h1 className="programs-hero-title">We are Here to Serve and Uplift the Community</h1>
          <p className="programs-hero-cta">
            CLICK ON A PROGRAM BELOW TO LEARN MORE<br />
            ABOUT OUR ADDITIONAL SERVICES ON OUR<br />
            OTHER WEBSITES
          </p>
        </div>
      </div>

      {/* Services Section - appears on white background from pseudo-element */}
      <section className="programs-services-section">
        <div className="programs-services-content">
          <div className="programs-services-image">
            <img src={require('../assets/programsBottom.png')} alt="Support team" />
          </div>
          <div className="programs-services-text">
            <h3 className="programs-services-header">OUR SERVICES ARE ALWAYS FREE & CONFIDENTIAL</h3>
            
            <div className="programs-service-item">
              <h4 className="programs-service-title">LGBT National Hotline</h4>
              <a href="tel:888-843-4564" className="programs-service-phone">888-843-4564</a>
            </div>

            <div className="programs-service-item">
              <h4 className="programs-service-title">LGBT National Coming Out Support Hotline</h4>
              <a href="tel:888-688-5428" className="programs-service-phone">888-688-5428</a>
            </div>

            <div className="programs-service-item">
              <h4 className="programs-service-title">LGBT National Youth Talkline</h4>
              <a href="tel:800-246-7743" className="programs-service-phone">800-246-7743</a>
            </div>

            <div className="programs-service-item">
              <h4 className="programs-service-title">LGBT National Senior Hotline</h4>
              <a href="tel:888-234-7243" className="programs-service-phone">888-234-7243</a>
            </div>

            <div className="programs-service-item">
              <h4 className="programs-service-title">LGBT One-to-One Online Chat</h4>
              <a href="https://lgbthotline.org/chat/" target="_blank" rel="noopener noreferrer">lgbthotline.org/chat</a>
            </div>


            <div className="programs-service-item">
            <h4 className="programs-service-title">Youth Moderated Chatrooms</h4>
              <a href="https://lgbthotline.org/youthchatrooms" target="_blank" rel="noopener noreferrer">lgbthotline.org/youthchatrooms</a>
            </div>

            <div className="programs-service-item">
            <h4 className="programs-service-title">LGBT Near Me Resources</h4>
              <a href="https://lgbtnearme.org" target="_blank" rel="noopener noreferrer">lgbtnearme.org</a>
            </div>
            
          </div>
        </div>
      </section>

    </div>
  );
};

export default Programs;